<template>
  <div>
    <company-logo />

    <div class="text-15 mt-24 text-gray-600 dark:text-gray-200">{{ t('login.welcomeTitle') }}</div>

    <div class="text-22 mt-4 font-semibold text-gray-800 dark:text-gray-50">{{ t('login.welcomeMessage') }}</div>
    <i18n-t
      keypath="login.termsAndPrivacy.legalText"
      tag="div"
      class="text-11 my-20 text-gray-700 dark:text-gray-100"
      scope="global"
    >
      <template #termsLink>
        <nuxt-link
          :to="{ name: 'termsOfService', query: { from: route.fullPath } }"
          target="_blank"
          class="text-blue-500 underline"
        >
          {{ t('login.termsAndPrivacy.termsLink') }}
        </nuxt-link>
      </template>

      <template #privacyLink>
        <nuxt-link :to="privacyPolicyUrl" target="_blank" class="text-blue-500 underline">
          {{ t('login.termsAndPrivacy.privacyLink') }}
        </nuxt-link>
      </template>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const route = useRoute();

const { privacyPolicyUrl } = storeToRefs(useDashboardCustomization());
</script>
